/**
 * 公式编辑器  zhanghengh
 * 2014/4
 * 主要用于资产、财务、供应链等
 *
 */
import React, { Component, Fragment } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import MetaAttr from './components/metaattr';
import Surface from './components/surface';
import AnchorNav from './components/anchorNav';
import Mentions from './components/mentions';
import classnames from "classnames";
import {
    Button,
    Tooltip,
    Tabs,
    TextArea,
    Modal,
    HotKeys,
    Input,
} from '@platform/base';

import { tinperClsPrefix, isFunction, isString, ajax, toast, getMultiLang, microAppUtil, myBrowser } from '@platform/api';
import ArrayStack from './utils/arrayStack';
const { TabPane } = Tabs;
const { Header, Title, Body, Footer } = Modal;

require('./index.less');

let associateData = []; // 用于公式联想 需要过滤的数据
export default class FormulaEditor extends Component {
    constructor(props) {
        super(props);
        this.selected = false;// textarea 中的文本是否被全选
        this.stackZ = new ArrayStack(); // 存储撤销的内容
        this.stackY = new ArrayStack(); // 存储恢复的内容
        this.isInputZh = false; // 是否是中文的拼音输入过程中
        this.state = {
            formulaData: [], //公式的数据
            cacheFormulaData: [], // 缓存公式的数据
            filterFormulaValue: '', // 公式过滤输入框的值
            activeFormula: -1, // 公式过滤中 当前选中的公式
            filterList: [], // 公式过滤中 所有符合的公式
            filterNum: 0, // 匹配到的公式数量
            initValue: '', // 编辑区的默认初始值
            showData: '', //展示出来的数据,
            isShow: false, //控制model展示隐藏
            isAssociate: false, // 是否开启函数联想
            associateValue: '', // 开启函数联想后 输入的值
            copyBoxStyle: {}, // textarea-copy-box的宽高
            mentionsPos: {}, // 存储函数联想内容的位置
            isMaximize: false, // 当前是否全屏
            isShowKeyBoard: false, // 是否显示键盘
            isShowMean: false, // 是否显示公式含义
            meaningData: '', // 公式含义内容
            containerHeight: '474px',
            tabPaneHeight: 'calc(100%-28px)', // 右侧变量区 tab height -- 大字体下tab-bar高度会变
            explainData: '', //解释数据
            activeName: '', //选中公式名称
            //选项按钮配置
            optBtnsConfig: [

                { name: 0 },
                { name: 1 },
                { name: 2 },
                { name: 3 },
                { name: 4 },
                { name: 5 },
                { name: '00' },
                { name: 6 },
                { name: 7 },
                { name: 8 },
                { name: 9 },
                { name: '.' },
            ],
            // 运算符配置
            computedBtnconfig: [
                { name: '+' },
                { name: '-' },
                { name: '*' },
                { name: '/' },
                { name: '->' },
                { name: '==' },
                { name: '(' },
                { name: ')' },
                { name: '<' },
                { name: '>' },
                { name: '<=' },
                { name: '>=' },
            ],
            json: {},
        };
        this.appBody = microAppUtil.getDocument();
    }

    async componentWillMount() {
        // 初始化调用getPlatformLang方法获取多语
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData }, () => {
                let { show = false } = this.props;
                this.setShow(show); // 设置modal展示和隐藏
            });
        };
        await getMultiLang({ moduleId: 'container_formulaEditor', callback }); // moduleId为所需加载json文件夹名称前缀
        const { value = '', show = false, noShowFormula, formulaUrl } = this.props;
        let { json } = this.state;

        // this.handleTextAreaChange(value); // 设置编辑器初始值
        (Array.isArray(noShowFormula) && noShowFormula.length === 1 && noShowFormula[0] === 'all') ||
            ajax({
                url: isString(formulaUrl) ? formulaUrl : '/nccloud/formula/web/formulatype.do',
                loading: false,
                success: res => {
                    this.setState({ formulaData: res.data, cacheFormulaData: res.data });
                },
                error: () => {
                    toast({ color: 'danger', content: `${json['formula0012']}` });
                },
            });
    }

    componentWillReceiveProps(nextProps) {
        const { value = '', show = false, noShowFormula, formulaUrl } = nextProps; //最新的props
        const { formulaUrl: oldFormulaUrl, show: oldShow } = this.props; //上一次的props
        // 关闭弹窗时清空一些数据
        if (!show && oldShow) {
            this.stackZ.clear();
            this.stackY.clear();
            this.setShow(show);
            this.setState({ showData: '', explainData: '', filterFormulaValue: '', initValue: '', isMaximize: false, isShowMean: false, isShowKeyBoard: false, containerHeight: '474px' });
            return;
        }
        let { json, initValue } = this.state;
        // if (initValue !== value) {
        //     this.setState({initValue: value})
        //     this.handleTextAreaChange(value);
        // }
        // textarea 中的文本全选状态变成false
        // this.selected && (this.selected = false);
        this.setShow(show); // 设置modal展示和隐藏
        if (formulaUrl !== oldFormulaUrl) {
            ////当传入的路径变化时才重新请求，做到优化作用
            (Array.isArray(noShowFormula) && noShowFormula.length === 1 && noShowFormula[0] === 'all') ||
                ajax({
                    url: isString(formulaUrl) ? formulaUrl : '/nccloud/formula/web/formulatype.do',
                    loading: false,
                    success: res => {
                        this.setState({ formulaData: res.data, cacheFormulaData: res.data });
                    },
                    error: () => {
                        toast({ color: 'danger', content: `${json['formula0012']}` });
                    },
                });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { value } = this.props;
        const { isShow: prevIsShow, } = prevState;
        const { isShow, initValue } = this.state;
        // 打开弹窗
        if (this.textArea && !prevIsShow && isShow) {
            if (!initValue && value) {
                this.setState({ initValue: value })
                this.handleTextAreaChange(value);
            }
        }
    }
    /**
     * 基础配置，用于创建内容区域
     * ================================================
     */
    /**
     * 公式编辑区-操作按钮
     */
    getControlBtnsConfig = () => {
        let { json, isShowMean, showData, isMaximize } = this.state;
        const { showControlBtns = [], noControlBtns = [], showAssociate = true } = this.props;
        const meaningShow = showControlBtns.includes('meaning');
        const validateShow = noControlBtns.includes('validate');
        // console.log("getControlBtnsConfig", this.stackZ.size())
        return [
            {
                key: 'associate',
                id: 'associate',
                className: this.state.isAssociate ? "associate-btn-acitve" : "",
                isShow: showAssociate,
                tooltip: 'Alt+R',
                iconName: 'icon-gsbjq-fx',
                onClick: () => this.handleFnAssociate("click")
            },
            {
                key: 'keyboard',
                isShow: true,
                tooltip: 'Ctrl+K',
                iconName: 'icon-gsbjq-jianpan',
                onClick: this.handleKeyboard
            },
            {
                key: 'undo',
                disabled: this.stackZ.size() < 1,
                isShow: true,
                tooltip: 'Ctrl+Z',
                iconName: 'icon-gsbjq-shangyibu',
                onClick: this.handleUndo
            },
            {
                key: 'redo',
                disabled: this.stackY.size() < 1,
                isShow: true,
                tooltip: 'Ctrl+Y',
                iconName: 'icon-gsbjq-xiayibu',
                onClick: this.handleRedo,
            },
            {
                key: 'clear',
                isShow: true,
                disabled: !showData,
                tooltip: 'Ctrl+Del',
                iconName: 'icon-gsbjq-shanchu',
                onClick: this.handleClear
            },
            {
                key: 'copy',
                isShow: true,
                disabled: !showData,
                tooltip: 'Ctrl+Shift+C',
                iconName: 'icon-gsbjq-fuzhi',
                onClick: this.handleCopy,
            },
            {
                key: 'meaning',
                colors: 'accent',
                isShow: meaningShow, // 默认隐藏
                tooltip: 'Alt+T',
                disabled: !showData,
                iconName: !isShowMean ? 'icon-gsbjq-zhuanyi' : 'icon-shuaxin1',
                onClick: this.handleFnMeaning,
            },
            {
                key: 'validate',
                name: json['formula005'],
                colors: 'primary',
                isShow: !validateShow, // 默认显示
                tooltip: 'Ctrl+Enter',
                onClick: this.handleValidate,
            },
            {
                key: 'maximize',
                isShow: true,
                iconName: isMaximize ? 'icon-zuixiaohua' : 'icon-zuidahua',
                onClick: this.handleMaximize
            },
        ];
    };

    /**
     * 弹窗底部按钮
     */
    getFooterCtlBtnsConfig = () => {
        let { json } = this.state;
        return (
            [
                {
                    key: 'ok',
                    name: json['formula003'],
                    colors: 'primary',
                    isShow: true,
                    tooltip: 'Alt+Y',
                    hotkeyDisplay: 'Y',
                    onClick: this.handleOk
                },
                {
                    key: 'cancel',
                    name: json['formula004'],
                    isShow: true,
                    tooltip: 'Alt+N',
                    hotkeyDisplay: 'N',
                    onClick: this.handleCancel
                },
            ]
        )
    };

    /**
     * 事件回调区域
     * ================================================
     */

    /**
     * 监听中文输入
     */
    setChineseListener = () => {
        // console.log("监听中文输入", this.textArea)
        this.textArea?.addEventListener(
            'compositionstart',
            this.setInputFlag.bind(this, true),
            false
        );
        this.textArea?.addEventListener(
            'compositionend',
            this.setInputFlag.bind(this, false),
            false,
        );
    }
    /**
     * 处理中文输入
     */
    setInputFlag = flag => {
        this.isInputZh = flag;
        // console.log(`中文输入中？${this.isInputZh}`)
        if (flag === false) {
            let textArea = this.textArea?.querySelectorAll('textarea')[0];
            if (textArea) {
                this.handleTextAreaChange(textArea.value, textArea)
            }
        }
    }
    /**
     * textarea输入回调
     */
    handleTextAreaChange = (value, origin) => {
        const { showData: preValue, isAssociate } = this.state;
        const _this = this;
        setTimeout(() => {// 使onchange事件在setInputFlag之后
            // console.log('🚀', 'color: #e43', "newValue:", value, ", oldValue:", preValue,", origin:", origin, "isInputZh", _this.isInputZh)
            if (_this.isInputZh) { return; };
            // 中文输入结束后 再入栈 preValue
            origin && value && _this.pushUndoStack(preValue);
            // 开启了函数联想 获取输入的第一个字符的位置
            let mentionsPos;
            if (isAssociate) {
                mentionsPos = this.getMentionsPosition();
            }
            this.setState({ showData: value, mentionsPos });
        }, 0)
    }
    /**
     * 数据 入栈
     */
    pushUndoStack = preValue => {
        // 撤销最多支持50步
        if (this.stackZ.size() === 50) {
            this.stackZ.shift();
        }
        this.stackZ.push(preValue);
        this.stackY.clear(); // 清空 恢复数组
        // console.log('%c pushUndoStack入栈,stackZ===', 'color:green', this.stackZ.size())
    }

    /**
     * 唤醒/关闭 函数联想
     */
    handleFnAssociate = event => {
        const { showData, isAssociate } = this.state;
        // 动态获取textarea宽高
        const textareaDom = this.appBody.querySelector('.editor-show-area');
        const textWidth = textareaDom?.offsetWidth;
        const textHeight = textareaDom?.offsetHeight;
        const copyBoxStyle = {
            width: textWidth,
            height: textHeight
        }
        // console.log("old isAssociate", isAssociate)
        this.setState({ isAssociate: !isAssociate, copyBoxStyle, mentionsPos: {}, associateValue: "" })
    }
    /**
     * 结束联想
     */
    setAssociateEnd = () => {
        // console.log("结束联想")
        // const _this = this;
        this.setState({ isAssociate: false })
    }
    /**
     * 获取 开启联想后 输入的第一个字符 联想框的位置
     */
    getMentionsPosition = () => {
        let { isMaximize, mentionsPos } = this.state;
        // textarea滚动卷起的高度
        const scrollTop = this.appBody.querySelector(".editor-show-area")?.scrollTop;
        // 获取用于定位联想位置的span标签
        const locationDom = this.appBody.querySelector("#position-span");
        const offsetTop = locationDom?.offsetTop;
        const offsetLeft = locationDom?.offsetLeft;
        // span标签的右边界到视窗左边的距离
        const locationRight = locationDom?.getBoundingClientRect().right;
        // 弹窗.formula-editor-modal-body内容区右边界到视窗左边的距离
        const modalBodyRight =  this.appBody.querySelector(`.formula-editor-modal-body`)?.getBoundingClientRect().right;
        const modalBodyBottom =  this.appBody.querySelector(`.formula-editor-modal-body`)?.getBoundingClientRect().bottom;
        // 给 函数联想框+函数说明框 预留的宽度
        const difference = modalBodyRight - locationRight;
        // console.log("modalBodyBottom", modalBodyBottom, locationDom?.getBoundingClientRect().bottom)
        let maxTop = 0;
        console.log("offsetTop:", offsetTop, "scrollTop:", scrollTop)
        if (isMaximize && modalBodyBottom - locationDom?.getBoundingClientRect().bottom < 90) {
            maxTop = offsetTop - scrollTop + 16 - 100
            console.log("maxTop:", maxTop)
        }
        switch (true) {
            // 放不下函数联想框
            case difference < 200:
                // console.log("< 200", difference)
                mentionsPos = {
                    dropdownTop: maxTop || offsetTop - scrollTop + 16,
                    dropdownLeft: offsetLeft - 202 + difference,
                    hintRight: 200,
                    // hintLeft: 0
                }
                break;
            // 放不下函数说明框
            case difference < 400:
                // console.log(" < 400", difference)
                mentionsPos = {
                    dropdownTop: maxTop || offsetTop - scrollTop + 16,
                    dropdownLeft: isMaximize ? offsetLeft + 16 : offsetLeft + 4,
                    hintRight: 200,
                    // hintLeft: 0
                }
                break;
            // 可以放下函数联想框+函数说明框
            default:
                // console.log("default", difference)
                mentionsPos = {
                    dropdownTop: maxTop || offsetTop - scrollTop + 16,
                    dropdownLeft: isMaximize ? offsetLeft + 16 : offsetLeft + 4,
                    // hintRight: 0,
                    hintLeft: 200,
                }
                break;
        }
        // console.log("mentionsPos", mentionsPos)
        // this.setState({mentionsPos})
        return mentionsPos;
    }
    /**
     * 获取 开启联想后 输入的内容
     * TODO 正则判断需要联想的关键字和switch判断
     */
    getAssociateValue = e => {
        // console.log(e.keyCode)
        let { associateValue } = this.state;
        const { keyCode } = e;
        // 38上 40下
        const keyCodeShield = [8, 13, 32, 37, 38, 39, 40, 16, 20, 192, 229]; // 屏蔽del、enter、空格、 方向键、快捷键 中文输入法229
        if (e.keyCode && !keyCodeShield.includes(e.keyCode)) {
            // console.log('开启联想后，输入中==', e.keyCode)
            const str = String.fromCharCode(e.keyCode);
            this.setState({ associateValue: associateValue += str }, () => {
                // console.log(associateValue)
            })
        } else if (e.keyCode === 8 && associateValue) { // 删除
            let { associateValue } = this.state;
            let newAssociateValue = associateValue.substring(0, associateValue.length - 1);
            this.setState({ associateValue: newAssociateValue })
        } else if ((e.keyCode === 32 || e.keyCode === 37 || e.keyCode === 39) && associateValue) {
            this.setState({ associateValue: "" })
        } else if ((e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) && associateValue) {
            e.preventDefault();
            this.associateHotkeys(e.keyCode);
        }
    }
    /**
     * 函数联想快捷键 上、下、enter 调用Mentions组件的方法
     */
    associateHotkeys = key => {
        const res = this.mentionsRef.handleHotkeys(key);
        res && this.setAssociateEnd();
    }
    /**
     * 函数联想插入文本,将associateValue替换为匹配的公式
     */
    handlePushFormula = formula => {
        const { showData, associateValue } = this.state;
        this.pushUndoStack(showData); // 将prevalue入栈
        let textArea =  this.appBody.querySelector('#formula-editor-wrap .editor-show-area');
        if (textArea) {
            // console.log("mentions输入", formula)
            let associateLen = associateValue.length;
            let textAreaLen = textArea.value.length;
            let textAreaValue = textArea.value;
            let selectionStart = textArea.selectionStart;
            let finalRange = (textAreaValue.substr(0, selectionStart - associateLen) + formula).length;
            let finalValue =
                textAreaValue.substr(0, selectionStart - associateLen) + formula + textAreaValue.substring(selectionStart, textAreaLen);
            this.setState({ showData: finalValue }, () => {
                this.setCursorPosition(textArea, finalRange);
            });
        }
    };
    /**
     * 显示键盘
     */
    handleKeyboard = () => {
        this.setState({ isShowKeyBoard: true });
    }
    /**
     * 收起键盘
     */
    closeKeyBoard = () => {
        this.setState({ isShowKeyBoard: false });
    }
    /**
     * 点击撤销
     */
    handleUndo = () => {
        const { showData } = this.state;
        // console.log("%c 撤销后stackZ=", 'color: green', this.stackZ.toString(), this.stackZ.size(), ")
        if (this.stackZ.size() > 0) { // 可撤销栈不为空
            const p = this.stackZ.pop();
            this.stackY.push(showData); // 压入可恢复栈
            this.setState({ showData: p })
            // console.log("%c 撤销==", 'color: green', 'p:', p, ", stackZ:", this.stackZ.size())
            // console.log('%c stackY入栈===','color:blue', this.stackY.size())
        } else {
            console.log('%c stackZ空', 'color:green')
        }
    }
    /**
     * 点击恢复
     */
    handleRedo = () => {
        const { showData } = this.state;
        if (this.stackY.size() > 0) {
            const p = this.stackY.pop();
            if (p == this.state.showData) {
                this.handleRedo();
            } else {
                this.stackZ.push(showData);
                this.setState({ showData: p })
                // console.log('%c stackZ入栈===','color:green', this.stackZ.size())
            }
            // console.log("%c 恢复==", 'color: blue', '恢复p:', p, ", stackY:", this.stackY.size())
        } else {
            console.log('%c stackY空了', 'color:blue')
        }
    }
    /**
     * 点击清除
     */
    handleClear = () => {
        const _this = this;
        const { showData } = this.state;
        this.pushUndoStack(showData);
        this.setState({ showData: '' }, () => {
            this.textArea.querySelectorAll('textarea')[0].focus();
        });
    };
    /**
     * 点击复制
     */
    handleCopy = () => {
        this.textArea.querySelectorAll('textarea')[0].select(); //实现全选
        document.execCommand("copy"); // 复制
        // 去掉上一版的selected判断 否则全选后无法focus到其他input
        // 全选的时候将状态设置成true 
        // this.selected = true;
    };
    /**
     * 获取转译内容
     */
    getMeaning = value => {
        //领域给平台传meaningUrl, meaningParam
        const { json } = this.state;
        const { meaningUrl, meaningParam } = this.props;
        const data = { ...meaningParam, formula: value };
        ajax({
            url: isString(meaningUrl) ? meaningUrl : '',
            loading: false,
            data,
            success: ({ data }) => {
                console.log(data)
                /**
                 * {
                 *   "success": true, // 始终返回true，领域说因为平台后台包装过
                 *   "data": {
                 *         "transferFlag": true, // 是否支持转译
                 *         "data": "转译内容"
                 *    }
                 * }
                 */
                this.setState({ meaningData: data.transferFlag ? data.data : `${json['formula0022']}` })
            },
            error: () => {
                this.setState({ meaningData: `${json['formula0022']}` })
            },
        });
    }
    /**
     * 打开函数转译面板
     */
    handleFnMeaning = () => {
        const { isShowMean, showData } = this.state;
        if (!isShowMean) { // 打开转译面板
            this.setState({ isShowMean: true }, () => this.getMeaning(showData))
        } else { //刷新
            this.getMeaning(showData)
        }
    }
    /**
     * 关闭函数转译面板
     */
    closeMeaningArea = () => {
        this.setState({ isShowMean: false })
    }
    /**add by zhanghengh
     * 点击验证回调
     */
    handleValidate = () => {
        const { showData, json } = this.state;
        const { validateUrl, validateData = {} } = this.props;
        if (!showData) {
            return toast({ color: 'warning', content: `${json['formula0026']}` });
        }
        ajax({
            url: isString(validateUrl) ? validateUrl : '/nccloud/formula/web/formulaverfify.do',
            loading: false,
            data: { formulastr: showData, ...validateData },
            success: res => {
                if (res.data.status === 'Y') {
                    toast({ color: 'success', content: `${json['formula0013']}` });
                } else if (res.data.status === 'N') {
                    toast({
                        color: 'danger',
                        content: res.data.error ? res.data.error : `${json['formula0014']}`,
                    });
                }
            },
            error: () => {
                toast({ color: 'danger', content: `${json['formula0015']}` });
            },
        });
    };
    /**
     * 最大化最小化编辑区
     */
    handleMaximize = () => {
        const { isMaximize: oldIsMaximize } = this.state;
        this.setState({ isMaximize: !oldIsMaximize });
    }
    /**
     * textarea获取光标
     */
    getCursorPosition = element => {
        if (!element) { return; };
        let cursorPos = 0;
        if (document.selection) {//IE
            var selectRange = document.selection.createRange();
            selectRange.moveStart('character', -element.value.length);
            cursorPos = selectRange.text.length;
        } else if (element.selectionStart || element.selectionStart == '0') {
            cursorPos = element.selectionStart;
        }
        return cursorPos;
    }

    /**
     * 清空开启过滤时 已选中的公式
     */
    clearCheckedFormula = filterList => {
        filterList.forEach((item, index) => item?.classList.remove("formula-filter-checked-item"));
        return filterList;
    }
    /**
     * 获取 所有过滤中匹配上的公式
     */
    getAllFilterFormulas = () => {
        return  this.appBody.querySelectorAll(".tab-content-item-filter");
    }
    /**
     * 存储 所有过滤中匹配上的公式、已匹配上的公式条数
     */
    setFilterFormulaConfig = filterList => {
        const { filterFormulaValue } = this.state;
        this.setState({ filterList, filterNum: !filterFormulaValue ? 0 : filterList.length })
        if (filterList.length) {
            let explain = filterList[0].dataset.explain;
            let index = filterList[0].dataset.index;
            // 鼠标单击
            let activeFormula = parseInt(index);
            this.setExplain(explain);
            let _active = filterList[activeFormula];
            this.setState({ activeFormula }, () => {
                _active.classList.add("formula-filter-checked-item");
                _active?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            })
        }else{
            this.setExplain('');
        }
    }
    /**
     * 公式过滤 输入回调
     */
    handleFormulaInput = value => {
        this.setState({ filterFormulaValue: value, activeFormula: -1 }, () => {
            const filterList = this.getAllFilterFormulas();
            this.clearCheckedFormula(filterList); // 清空选中状态
            this.setFilterFormulaConfig(filterList); // 存储所有过滤中匹配上的公式、已匹配上的公式条数
        })
    }
    /**
     * 公式过滤快捷键 上、下、鼠标单击选中条目
     */
    filterFormulaHotkey = key => {
        let { filterFormulaValue, activeFormula, filterList } = this.state;
        // 未开启搜索||搜索到0条公式
        if (!filterFormulaValue || !filterList.length) {return;};
        // 清空其他选中状态
        filterList = this.clearCheckedFormula(filterList);
        let len = filterList.length;
        // 上
        if (key === 'up') {
            if (activeFormula === -1 || activeFormula === 0) {
                activeFormula = len - 1;
            } else {
                activeFormula--;
            }
        } else if (key === 'down') {
            // 下
            if (activeFormula === len - 1) {
                activeFormula = 0;
            } else {
                activeFormula++;
            }
        } else {
            // 鼠标单击
            activeFormula = parseInt(key.currentTarget?.dataset.index);
            this.handleClickTabItem(key);
        }
        // console.log('activeFormula', activeFormula)
        let _active = filterList[activeFormula];
        this.setState({ activeFormula }, () => {
            _active.classList.add("formula-filter-checked-item");
            _active?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        })
    }

    /**add by zhanghengh
     * 设置公式编辑器的显示和隐藏
     */
    setShow = value => {
        this.setState({ isShow: value });
    };
    /**add by zhanghengh
     * 向文本域设置选中值的方法
     * e | 事件对象
     */
    handelSetName = e => {
        const name = e.target.dataset.name || e.currentTarget.dataset.name;
        this.handlePushStr(name);
    };

    /**add by zhanghengh
     * 点击tabitem的回调
     * e | 事件对象
     */
    handleClickTabItem = e => {
        const explain = e.target.dataset.explain || e.currentTarget.dataset.explain;
        let name = e.target.dataset.name || e.currentTarget.dataset.name;
        this.setState({ activeName: name });
        this.setExplain(explain);
    };
    /**
     * zhanghengh
     *设置需要展示的解释字段方法
     */
    setExplain = data => {
        this.setState({ explainData: data });
    };

    /** add by zhanghengh
     * 点击取消回调
     */
    handleCancel = () => {
        const { onCancel } = this.props;
        if (onCancel && isFunction(onCancel)) {
            onCancel();
        }else {
            this.setShow(false);
        }
    };

    /**add by zhanghengh
     * 点击确认回调
     */
    handleOk = () => {
        console.log("handleOk");
        const { showData, json } = this.state;
        const { onOk, isValidateOnOK = true, validateUrl, validateData = {} } = this.props;
        if (isValidateOnOK) {
            //判断确定的时候是否需要校验
            ajax({
                url: isString(validateUrl) ? validateUrl : '/nccloud/formula/web/formulaverfify.do',
                loading: false,
                data: { formulastr: showData, ...validateData },
                success: res => {
                    if (res.data.status === 'Y') {
                        if (onOk && isFunction(onOk)) {
                            this.setShow(false);
                            onOk(showData);
                        }
                    } else if (res.data.status === 'N') {
                        toast({
                            color: 'danger',
                            content: res.data.error ? res.data.error : `${json['formula0014']}`,
                        });
                    }
                },
                error: () => {
                    toast({ color: 'danger', content: `${json['formula0015']}` });
                },
            });
        } else {
            if (onOk && isFunction(onOk)) {
                this.setShow(false);
                onOk(showData);
            }

        }
    };

    /**add by zhanghengh
     * 在光标位置插入文本，插入文本后光标位置不变
     * @param {*} btnContent //按钮的内容
     */
    handlePushStr = btnContent => {
        const { showData } = this.state;
        this.pushUndoStack(showData); // 将prevalue入栈
        let textArea =  this.appBody.querySelector('#formula-editor-wrap .editor-show-area');
        if (textArea) {
            if (this.selected) {
                // 全选后,在选择的值,直接覆盖之前的值解决  CLOUD-166749 这个bug, 财务 杨龙,和测试周崚 让改
                this.selected = false;
                this.setState({ showData: btnContent }, () => {
                    this.setCursorPosition(textArea, btnContent.length);
                });
            } else {
                let textAreaLen = textArea.value.length;
                let textAreaValue = textArea.value;
                let selectionStart = textArea.selectionStart;
                let finalRange = (textAreaValue.substr(0, selectionStart) + btnContent).length;
                let finalValue =
                    textAreaValue.substr(0, selectionStart) + btnContent + textAreaValue.substring(selectionStart, textAreaLen);
                this.setState({ showData: finalValue }, () => {
                    this.setCursorPosition(textArea, finalRange);
                });
            }
        }
    };

    /**
     * 设置输入域(input/textarea)光标的位置
     */
    setCursorPosition = (elem, index) => {
        var val = elem.value;
        var len = val.length;
        // console.log("%c setCursorPosition", 'color: pink', elem, index)
        // 超过文本长度直接返回
        if (len < index) {return;};
        // setTimeout(function () {
        elem.focus();
        if (elem.setSelectionRange) {
            // 标准浏览器
            elem.setSelectionRange(index, index);
        } else {
            // IE9- 这个里面有问题在看
            var range = elem.createTextRange();
            range.moveStart('character', -len);
            range.moveEnd('character', -len);
            range.moveStart('character', index);
            range.moveEnd('character', 0);
            range.select();
        }
        // }, 10);
    };

    /**
     * 创建内容区域 ======================================
     */
    /**
     * 创建键盘区域
     */
    _createKeyBoard = () => {
        const { optBtnsConfig, computedBtnconfig, json } = this.state;
        // const numberTitle = 'number';
        const numberTitle = json['formula0024'];
        const cooperatorTitle = json['formula0025'];
        // const cooperatorTitle = 'cooperator';
        console.log(numberTitle, numberTitle)
        return (
            <div className={classnames("keyboard-area", numberTitle !== '数字' ? "not-chinese" : "")}>
                <div className={classnames("editor-opt-btns")}>
                    <span className={classnames("editor-opt-title")}>{numberTitle}</span>
                    {this._createOptBtns(optBtnsConfig)}
                </div>
                <div className={classnames("editor-comp-btns")}>
                    <span className={classnames("editor-comp-title")}>{cooperatorTitle}</span>
                    {this._createOptBtns(computedBtnconfig)}
                </div>

                <div className="editor-comp-close">
                    <span onClick={this.closeKeyBoard} ><i className="iconfont icon-guanbi"></i></span>
                </div>
            </div>
        )
    }
    /**
     * 创建函数转译区
     */
    _createMeaningArea = () => {
        const { meaningData } = this.state;
        return (
            <div className="meaning-area">
                {meaningData}
                <span onClick={this.closeMeaningArea} className="meaning-area-close">
                    <i className="iconfont icon-guanbi"></i>
                </span>
                <span className="meaning-arrow"></span>
            </div>
        )
    }
    /**
     * 创建函数联想
     */
    _createCopyBox = () => {
        const { copyBoxStyle, showData, mentionsPos, associateValue } = this.state;
        const textareaDom =  this.appBody.querySelector('.editor-show-area');
        // 获取textarea真实光标位置
        const cursorPos = this.getCursorPosition(textareaDom);
        let mockShowData = showData;
        let _before = mockShowData?.slice(0, cursorPos);
        let _last = mockShowData?.slice(cursorPos);
        return (
            <Fragment>
                <div className="textarea-copy-box" style={{ ...copyBoxStyle }}>
                    {_before}
                    <span id="position-span"></span>
                    {_last}
                </div>
                {
                    <Mentions
                        onRef={c => this.mentionsRef = c}
                        coordinate={mentionsPos}
                        value={associateValue}
                        formulaList={associateData}
                        setName={this.handlePushFormula}
                    />
                }
            </Fragment>
        )
    }

    /**
     * add by zhanghengh
     * 创建键盘区域的选项按钮组
     * btnConfig | Array 按钮配置项数组
     */
    _createOptBtns = btnConfig => {
        return btnConfig.map((eve, index) => {
            const { name } = eve;
            return (
                <span onClick={this.handelSetName} key={index} data-name={name} className="opt-btn">
                    {name}
                </span>
            );
        });
    };
    /**
     * 创建编辑区
     */
    _createEditArea = () => {
        const { isMaximize, containerHeight, isShowKeyBoard, isShowMean, showData, isAssociate, associateValue } = this.state;
        return (
            <div className={classnames({
                "editor-submit-area": true,
                "editor-maximize": isMaximize,
                "editor-minimize": !isMaximize,
            })} style={{ height: isMaximize ? containerHeight : "calc(100% - 230px)" }}>
                <HotKeys
                    keyMap={{
                        FnAssociate: ["alt+r"],
                        keyboard: "ctrl+k",
                        undo: "ctrl+z",
                        redo: "ctrl+y",
                        clear: "ctrl+del",
                        copy: "ctrl+shift+c",
                        meaning: "alt+t",
                        validate: "ctrl+enter",
                    }}
                    handlers={{
                        FnAssociate: this.handleFnAssociate,
                        keyboard: this.handleKeyboard,
                        undo: this.handleUndo,
                        redo: this.handleRedo,
                        clear: this.handleClear,
                        copy: this.handleCopy,
                        meaning: this.handleFnMeaning,
                        validate: this.handleValidate,
                    }}
                    enabled={true}
                    attach={false}
                    display="block"
                    className={classnames("textarea-hotkey")}
                    style={{ height: isShowMean ? "calc(50% - 18px)" : "" }}
                >
                    <TextArea
                        ref={dom => {
                            this.textArea = findDOMNode(dom);
                        }}
                        selfRangControl={false}
                        onBlur={
                            () => {
                                // 全选的时候让textarea里面的文本一直处于全选的状态
                                // this.selected && (this.textArea.querySelectorAll('textarea')[0].select());
                                // console.log("onblur", this.state.isAssociate)
                                isAssociate && this.setAssociateEnd() // 失焦时关闭联想状态
                            }
                        }
                        value={showData}
                        className="editor-show-area"
                        onChange={this.handleTextAreaChange}
                        onEnter={() => { }}//为了ctrl+enter换行
                        formularEditorCanInsert={isAssociate ? false : true}
                        fieldid="editor"
                        onClick={() => {
                            if (isAssociate && associateValue) {
                                this.setState({ associateValue: "" })
                            }
                        }}
                        isFormularEditor={true}
                        onKeyDown={isAssociate && this.getAssociateValue}
                    />
                </HotKeys>
                {/* 创建函数联想气泡框 */}
                {/* {this._createCopyBox()} */}
                {isAssociate ? this._createCopyBox() : ''}

                {/* 函数含义 */}
                {isShowMean ? this._createMeaningArea() : ''}

                {/* 键盘收放 */}
                <div className="editor-control-btns">
                    {
                        isShowKeyBoard ? this._createKeyBoard() : <div className="ctl-button-area">
                            {this._createControlBtns(this.getControlBtnsConfig())}
                        </div>
                    }
                </div>
            </div>
        );
    };
    /**
     * 函数说明区的默认展示
     */
    _createDefaultExplain = () => {
        const { json } = this.state;
        return (
            // <div className="explain-default">
            //     <span className="explain-img"></span>
            //     <span className="explain-info">{json['formula0023']}</span>
            // </div>
            `<div class="explain-default"><span class="explain-img"></span><span class="explain-info">{${json['formula0023']}}</span></div>`
        )
    }
    /**
     * 创建操作按钮组
     */
    _createControlBtns = btnConfig => {
        return btnConfig.map((eve, index) => {
            const { name, iconName, onClick, isShow, key, colors, disabled, hotkeyDisplay, tooltip, className, ...params } = eve;
            return (
                isShow && (
                    !disabled ?
                        <Tooltip
                            placement="bottom"
                            overlay={disabled ? "" : tooltip}
                            delayShow={500}
                        >
                            <Button key={index} onClick={onClick} fieldid={key} colors={colors} disabled={disabled} {...params} className={className}>
                                {name ?
                                    (<span>
                                        {name}
                                        {hotkeyDisplay ?
                                            <span>(<span className="text-decoration-underline">{hotkeyDisplay}</span>)</span> :
                                            ''}
                                    </span>) :
                                    <i className={classnames("iconfont", iconName)} ></i>
                                }
                            </Button>
                        </Tooltip> :
                        // 解决：按钮显示tip时被禁用，当解除禁用时，未hover时直接显示tip
                        <Button key={index} onClick={onClick} fieldid={key} colors={colors} disabled={disabled} {...params}>
                            {name ?
                                (<span>
                                    {name}
                                    {hotkeyDisplay ?
                                        <span className="text-decoration-underline">{hotkeyDisplay}</span> :
                                        ''}
                                </span>) :
                                <i className={classnames("iconfont", iconName)} ></i>
                            }
                        </Button>
                )
            );
        });
    };
    /**
     *  新 创建函数展示区 展示所有
     */
    _createFormulaArea = () => {
        let {
            formulaConfig = [],
            noShowFormula,
            defaultFormulaKey,
            onTabChange,
            showSearch = true, // 默认开启搜索
        } = this.props;
        let { formulaData, filterFormulaValue, filterNum, json } = this.state;
        let defaultFormulaObj = isString(defaultFormulaKey) ? { defaultActiveKey: defaultFormulaKey } : {}; //  公式tab的默认展示tab
        let tabFormulaConfig = formulaData.map(eve => {
            // 内置的公式条目
            return {
                tab: eve.typeName,
                key: eve.typeName,
                TabPaneContent: eve.name2FormItemMap,
            };
        });
        if (Array.isArray(noShowFormula) && noShowFormula.length > 0) {
            //对用户不需要的tab公式进行筛选
            if (noShowFormula.length === 1 && noShowFormula[0] === 'all') {
                //  隐藏所有tab页签
                tabFormulaConfig = [];
                formulaConfig = [];
            } else if (noShowFormula.length === 1 && noShowFormula[0] === 'allBuiltIn') {
                //  隐藏所有内置tab页签
                tabFormulaConfig = [];
            } else {
                tabFormulaConfig = tabFormulaConfig.filter(eve => {
                    //内置的
                    let isChange = true;
                    noShowFormula.forEach(attr => {
                        if (attr === eve.key) {
                            isChange = false;
                        }
                    });
                    return isChange;
                });
                formulaConfig = formulaConfig.filter(eve => {
                    //用户传入的
                    let isChange = true;
                    noShowFormula.forEach(attr => {
                        if (attr === eve.key) {
                            isChange = false;
                        }
                    });
                    return isChange;
                });
            }
        }
        const original = formulaConfig.concat(tabFormulaConfig)
        // console.log(original)
        const { tabs, TabPaneContent } = this._createFormulaAllItmes(original); // 所有Tabs+content
        return (
            <div className="formula-area">
                <HotKeys
                    keyMap={{
                        up: "up",
                        down: "down",
                    }}
                    handlers={{
                        up: () => this.filterFormulaHotkey('up'),
                        down: () => this.filterFormulaHotkey('down'),
                    }}
                    enabled={true}
                    attach={false}
                    display="block"
                >
                    <span className="filter-num">
                        {!filterNum ? '' : filterNum}
                    </span>

                    {
                        showSearch && <Input
                            className="formula-search"
                            showClose={true}
                            placeholder={json['formula0020']}
                            value={filterFormulaValue}
                            onChange={this.handleFormulaInput}
                            type="search"
                        />
                    }
                    {/* 锚点导航 加载完所有数据后再渲染锚点导航组件*/}
                    {formulaData?.length > 0 ? <AnchorNav tabs={tabs} /> : ''}
                    {/* {<AnchorNav tabs={tabs}/>} */}

                    {/* 要渲染的公式列表，领域自制内容不参与搜索 */}
                    <ul className="formula-tab-content">
                        {
                            TabPaneContent.map(item => {
                                return item
                            })
                        }
                    </ul>
                </HotKeys>

            </div>
        )
    }
    /**
     * 新 创建公式展示区
     */
    _createFormulaAllItmes = original => {
        const { filterFormulaValue } = this.state;
        let { displayTitleByLength=false } = this.props;
        const searchValue = filterFormulaValue?.toLowerCase();
        // console.log('searchValue: ', searchValue)
        const _this = this;
        // 用于锚点导航组件的标题
        let formulaTabsAll = [];
        // 用于展示列表中的标题+公式条目dom
        let TabPaneContent = [];
        // tab+content
        let resObj = {};
        // 用于函数联想的所有公式
        let DataForAssociate = [];
        // 函数过滤时，单击公式存储下标
        let dataIndex = -1;
        // 遍历预制和传入的所有公式 区分是否参与过滤
        original.map((eve, index) => {
            /**
             * 参与过滤的纯数据
             */
            if (Array.isArray(eve.TabPaneContent)) {
                /**
                 * 未开启搜索时
                 */
                if (!searchValue) {
                    // 用于公式列表中的标题
                    const Title = <li className="formula-anchor" id={`formula-anchor${index}`}>{eve.tab}</li>;
                    TabPaneContent.push(Title);
                    // 用于锚点导航组件的标题
                    formulaTabsAll.push({ name: eve.tab, id: `formula-anchor${index}`, len: eve.TabPaneContent.length });
                    eve.TabPaneContent.map(e => {
                        DataForAssociate.push({ displayName: e.displayName, inputSig: e.inputSig, hintMsg: e.hintMsg, category: eve.tab });
                        return TabPaneContent.push(<li className={`${this.state.explainData === e.hintMsg && this.state.activeName === e.inputSig ? "tab-content-item-active tab-content-item" : "tab-content-item"}`} data-name={e.inputSig} title={e.inputSig} data-explain={e.hintMsg} onClick={this.handleClickTabItem} onDoubleClick={this.handelSetName}>{e.displayName}</li>);
                    })
                    associateData = DataForAssociate;
                    // console.log('associateData', associateData)
                } else {
                    /**
                     * 
                     * 开启搜索时
                     */
                    // 过滤匹配上的公式条数
                    let num = 0;
                    // 用于公式列表中的标题
                    const Title = <li className="formula-anchor" id={`formula-anchor${index}`}>{eve.tab}</li>;
                    TabPaneContent.push(Title)
                    eve.TabPaneContent.map(e => {
                        const displayName = e.displayName.toLowerCase();
                        const hintMsg = e.hintMsg.toLowerCase();
                        const display_index = displayName.indexOf(searchValue);
                        const hint_index = hintMsg.indexOf(searchValue);
                        if (display_index < 0 && hint_index < 0) {return;}; // 不匹配
                        num++;
                        dataIndex++;
                        let title = (
                            <span className="filter-span">
                                <span style={{ color: '#f53c32' }}>
                                    {displayName}
                                </span>
                            </span>);
                        if (display_index > 0) {
                            const beforeStr = displayName.substr(0, display_index);
                            const inputStr = displayName.substr(display_index, searchValue.length)
                            const afterStr = displayName.substr(display_index + searchValue.length);
                            title = (
                                <span className="filter-span">
                                    {beforeStr}
                                    <span style={{ color: '#f53c32' }}>
                                        {inputStr}
                                    </span>
                                    {afterStr}
                                </span>
                            )
                        }
                        // console.log(_index, beforeStr,inputStr, afterStr)
                        return TabPaneContent.push(<li className={`${this.state.explainData === e.hintMsg && this.state.activeName === e.inputSig ? "tab-content-item-active tab-content-item tab-content-item-filter" : "tab-content-item tab-content-item-filter"}`} data-name={e.inputSig} data-explain={e.hintMsg} data-index={dataIndex} onClick={this.filterFormulaHotkey} onDoubleClick={this.handelSetName}>{title}</li>);
                    })
                    if (num === 0) { // 没有匹配的公式, 从TabPaneContent中删除对应的标题
                        TabPaneContent = TabPaneContent.filter(item => {
                            return item.props.id !== `formula-anchor${index}`
                        })
                        return;
                    }
                    // 用于锚点导航组件的标题
                    formulaTabsAll.push({ name: eve.tab, id: `formula-anchor${index}`, len: num });
                }
            } else {
                /**
                 * 不参与过滤的领域自制内容
                 */
                // 用于公式列表中的标题
                const Title = <li className="formula-anchor" id={`formula-anchor${index}`}>{eve.tab}</li>;
                TabPaneContent.push(Title)
                // 用于锚点导航组件的标题
                formulaTabsAll.push({ name: eve.tab, id: `formula-anchor${index}`, len: eve.contentLen });
                // 不需要搜索的自制内容
                TabPaneContent.push(_this._createCustomRes(eve.TabPaneContent, eve.params));
            }
        })
        // 如果值匹配到一个标题下的内容，并且displayTitleByLength为true那就隐藏标题
        if(displayTitleByLength){
            let titleData = TabPaneContent.filter(item => item.props.id?.includes(`formula-anchor`));
            if(titleData.length === 1){
                let spliceIndex = TabPaneContent.indexOf(titleData[0]);
                TabPaneContent.splice(spliceIndex,1)
            }
        }
        resObj.tabs = formulaTabsAll;
        resObj.TabPaneContent = TabPaneContent;
        return resObj;
    };
    /**
     * 创建自定义内容
     */
    _createCustomRes = (TabPaneContent, params) => { // params中包括领域传入的json多语
        return <TabPaneContent setExplain={this.setExplain} setName={this.handlePushStr} {...params} />
    }

    /**
     * 创建右侧变量展示区
     */
    _createAttrArea = () => {
        let {
            attrConfig = [],
            noShowAttr,
            tabActiveKey,
            defaultAttrKey,
            onTabChange,
            className
        } = this.props;
        let { json, isMaximize } = this.state;
        let defaultAttrObj = isString(defaultAttrKey) ? { defaultActiveKey: defaultAttrKey } : {}; //  属性tab的默认展示tab
        let tabActiveKeyObj = isString(tabActiveKey) ? { activeKey: tabActiveKey } : {};
        let tabAttrConfig = [];
        if (json['formula008']) {
            tabAttrConfig = [
                //右侧tabPane配置数据
                {
                    tab: `${json['formula008']}`,
                    key: `${json['formula008']}`,
                    TabPaneContent: MetaAttr,
                },
                {
                    tab: `${json['formula009']}`,
                    key: `${json['formula009']}`,
                    TabPaneContent: Surface,
                },
            ];
        }
        attrConfig = attrConfig.filter(attr => !!attr && attr.tab); // 领域可能传入false
        Array.isArray(attrConfig) && (tabAttrConfig = tabAttrConfig.concat(attrConfig)); //判断右侧tabs配置
        if (Array.isArray(noShowAttr) && noShowAttr.length > 0) {
            //对用户不需要tab属性的进行筛选
            if (noShowAttr.length === 1 && noShowAttr[0] === 'all') {
                //  隐藏所有tab页签
                tabAttrConfig = [];
            } else if (noShowAttr.length === 1 && noShowAttr[0] === 'allBuiltIn') {
                tabAttrConfig = attrConfig;
            } else {
                tabAttrConfig = tabAttrConfig.filter(eve => {
                    let isChange = true;
                    noShowAttr.forEach(attr => {
                        if (attr === eve.key || (eve.key && eve.key.includes(attr))) {
                            // 这是实现有些问题，暂时兼容一下
                            isChange = false;
                        }
                    });
                    return isChange;
                });
            }
        }
        return (
            <div className={classnames({
                "editor-wrap-right": true,
                "hidden": isMaximize,
            })}>
                <Tabs
                    className={`${className} editor-wrap-right-tabs`}
                    tabBarStyle="line"
                    {...defaultAttrObj}
                    destroyInactiveTabPane={true}
                    onChange={key => {
                        isFunction(onTabChange) && onTabChange(key);
                    }}
                    {...tabActiveKeyObj}
                    moreType="moreTabsArrow"
                >
                    {this._createAttrTabPanes(tabAttrConfig)}
                </Tabs>
            </div>
        )
    }

    /**
     * add by zhanghengh
     * 创建右侧TabPanes
     * tabPaneConfig | Array TabPane配置
     */
    _createAttrTabPanes = tabPaneConfig => {
        const { metaParam, metaUrl, surfaceUrl } = this.props;
        const { tabPaneHeight } = this.state;
        return tabPaneConfig.map(eve => {
            const { TabPaneContent, tab, params = {}, key } = eve;
            return (
                <TabPane tab={tab} style={{ height: tabPaneHeight }} key={key}>
                    <TabPaneContent
                        setExplain={this.setExplain}
                        setName={this.handlePushStr}
                        metaParam={metaParam}
                        metaUrl={metaUrl}
                        surfaceUrl={surfaceUrl}
                        tabPaneHeight={tabPaneHeight}
                        {...params}
                    />
                </TabPane>
            );
        });
    };

    render() {
        // 解释区域显示文字
        let { isShow, isShowKeyBoard, json, explainData, isMaximize, containerHeight } = this.state;
        const { onHide = () => { }, className = '', message = '', zIndex, width = 948, minWidth = 948 } = this.props; // width、min-width-->成本动因-李乾坤-没有右侧变量区内容
        let isFireFox = myBrowser() == 'Firefox';
        if (containerHeight && typeof containerHeight === 'string') {
            containerHeight = parseInt(containerHeight);
        }
        return (
            <div>
                {isShow && !this.exiting && <Modal
                    id="formula-editor-wrap"
                    className={`${className} formula-editor-wrap ${isFireFox && 'modal-in-firefox'}`}
                    size="lg"
                    visible={isShow && !this.exiting}
                    mask="static" //是否展示遮罩层
                    // modalAutoFocus={false} // 取消自动聚焦焦点的操作
                    onCancel={onHide}
                    // centered={false}
                    // onExit={() => {
                    //     // 隐藏开始
                    //     this.setState({ showData: '' });
                    //     this.exiting = true;
                    // }}
                    // onExited={() => {
                    //     // 隐藏结束  为了解决input focus 弹出面板时  关闭弹窗触发focus事件  特此延时以让一定时间内不会二次弹出
                    //     setTimeout(() => {
                    //         this.exiting = false; // 不确定这里是否会产生 内存问题  可以考虑把这个变量放到全局去  应该也不会产生问题
                    //     }, 0);
                    // }}
                    onHide={() => {
                        this.setState({ showData: '' });
                        this.exiting = true;
                        setTimeout(() => {
                            this.exiting = false; // 不确定这里是否会产生 内存问题  可以考虑把这个变量放到全局去  应该也不会产生问题
                        }, 0);
                    }}
                    onResizeStop={() => {
                        // let modalbody =  this.appBody.querySelector(`.formula-editor-wrap .formula-editor-modal-body`)
                        // if (modalbody) {
                        //     if (modalbody.offsetHeight > 0) {
                        //         let tabPaneHeight = modalbody.offsetHeight - 297
                        //         this.setState({ tabPaneHeight, containerHeight: modalbody.offsetHeight - 45 })
                        //     }
                        // }
                        // const formulaWrap =  this.appBody.querySelector('.formula-editor-wrap');
                        const formulaResizeWrap =  this.appBody.querySelector('.formula-editor-wrap .modal-content-resizeWrap');
                        if (formulaResizeWrap) {
                            const containerHeight = formulaResizeWrap.offsetHeight - 86;
                            const tabBarHeight =  this.appBody.querySelector(`.editor-wrap-right-tabs .${tinperClsPrefix}-tabs-bar`)?.offsetHeight;
                            const tabPaneHeight = tabBarHeight ? (containerHeight - 16 - tabBarHeight) : 28;
                            console.log('tabBarHeight', tabBarHeight, tabPaneHeight)
                            this.setState({ containerHeight, tabPaneHeight })
                        }
                    }}
                    // onEnter={() => {
                    //     // let containerHeight = document.body.offsetHeight - 42 - 45
                    //     // if (containerHeight < 435) {
                    //     //     containerHeight = 435
                    //     // } else if (containerHeight > 535) {
                    //     //     containerHeight = 535
                    //     // }

                    //     // this.setState({ containerHeight: containerHeight + 'px' },() => {console.log('onEnter**********')})
                    // }}
                    onEntered={dom => {
                        const textArea = this.textArea?.querySelectorAll('textarea')[0];
                        if (textArea) {
                            this.setChineseListener();
                            this.setCursorPosition(textArea, textArea.value?.length); // 兼容其他火狐浏览器,火狐浏览器默认光标在第一位，而chrome默认在最后一位
                        }

                        // let modalbody = dom.querySelector(`.formula-editor-modal-body`).offsetHeight
                        // if (modalbody) {
                        //     if (modalbody.offsetHeight > 0) {
                        //         let tabPaneHeight = modalbody.offsetHeight - 287
                        //         this.setState({ tabPaneHeight })
                        //     }
                        // }
                        // const formulaResizeWrap =  this.appBody.querySelector('.formula-editor-wrap .modal-content-resizeWrap');
                        // const containerHeight = formulaResizeWrap.offsetHeight - 86;

                        // const tabBarHeight =  this.appBody.querySelector(`.editor-wrap-right-tabs .${tinperClsPrefix}-tabs-bar`)?.offsetHeight;
                        // const tabPaneHeight = tabBarHeight ? (containerHeight - 16 - tabBarHeight) : 28;
                        // console.log('tabBarHeight', tabBarHeight, tabPaneHeight)
                        // this.setState({ containerHeight, tabPaneHeight })
                    }}
                    onShow={dom => {
                        const formulaResizeWrap = this.appBody.querySelector('.formula-editor-wrap .modal-content-resizeWrap');
                        if (formulaResizeWrap) {
                            const containerHeight = formulaResizeWrap.offsetHeight - 86;
                            const tabBarHeight = this.appBody.querySelector(`.editor-wrap-right-tabs .${tinperClsPrefix}-tabs-bar`)?.offsetHeight;
                            const tabPaneHeight = tabBarHeight ? (containerHeight - 16 - tabBarHeight) : 28;
                            console.log('tabBarHeight', tabBarHeight, tabPaneHeight)
                            this.setState({ containerHeight, tabPaneHeight })
                        }
                    }}
                    minHeight={400}
                    width={width}
                    minWidth={minWidth}
                    zIndex={zIndex}
                    fieldid="formulaEditor"
                >

                    <Header closeButton className="formula-editor-modal-header">
                        <Title fieldid={`${json['formula0016']}`}>
                            <span className='formula-editor-modal-header-title' >{json['formula0016']} </span>
                            <span style={{ marginLeft: '20px' }}>{message}</span>
                        </Title>
                    </Header>
                    <Body className="formula-editor-modal-body">
                        {
                            // isMaximize ?
                            //     this._createEditArea() :
                            <div className="editor-containers" style={{ height: containerHeight - 1 }}>
                                <div className={classnames({
                                    "editor-wrap-left": true,
                                    "full-width": isMaximize,
                                })}>
                                    {/* 编辑区 */}
                                    {this._createEditArea()}

                                    <div className={classnames({
                                        "formula-and-explain": true,
                                        "hidden": isMaximize,
                                    })} >
                                        {/* 函数展示区 */}
                                        {this._createFormulaArea()}

                                        {/* 说明展示区 */}
                                        {/* <div className="explain-area">
                                                {explainData || t`  `   his._createDefaultExplain()}
                                            </div> */}
                                        <div
                                            className="explain-area"
                                            dangerouslySetInnerHTML={{ __html: (explainData || this._createDefaultExplain()) }}
                                        >
                                        </div>
                                    </div>


                                </div>

                                {/* 右侧变量展示区 */}
                                {this._createAttrArea()}
                            </div>
                        }
                    </Body>
                    <Footer className="formula-editor-modal-footer">
                        <HotKeys
                            keyMap={{
                                onOk: "alt+y",
                                cancel: {
                                    sequence: "alt+n",// 弹窗的确定按钮
                                    action: 'keyup', // 弹窗的取消按钮
                                },
                            }}
                            handlers={{
                                onOk: this.handleOk,
                                cancel: this.handleCancel
                            }}
                            // enabled={true}
                            focused={true}
                            className="formula-hotkeys-box"
                            attach={document.body}
                            display="inline" />
                        {this._createControlBtns(this.getFooterCtlBtnsConfig())}
                    </Footer>
                </Modal>}

            </div>
        );
    }
}

FormulaEditor.defaultProps = {
    formulaConfig: [], //左侧tab配置
    attrConfig: [], //右侧tab配置
    onOk: () => { }, //点击确定回调
};
FormulaEditor.propTypes = {
    formulaConfig: PropTypes.array, //左侧tab配置
    attrConfig: PropTypes.array, //右侧tab配置
    metaParam: PropTypes.object, //元素与属性请求参数
    metaUrl: PropTypes.string, //元素与属性的请求路径
    surfaceUrl: PropTypes.string, //表和字段的请求路径
    formulaUrl: PropTypes.string, //公式的的请求路径
    validateUrl: PropTypes.string, //自定义的验证接口
    meaningUrl: PropTypes.string, // 公式转译接口
    meaningParam: PropTypes.object, //公式转译请求参数
    onOk: PropTypes.func, //点击确定回调
    value: PropTypes.string, //设置编辑器的值
    show: PropTypes.bool, //控制模态框展示和隐藏
    noShowFormula: PropTypes.array, //公式tab不展示那些项
    noShowAttr: PropTypes.array, //属性tab不展示那些项
    onHide: PropTypes.func, //点击x按钮的回调
    showControlBtns: PropTypes.array, //需要展示的操作按钮
    noControlBtns: PropTypes.array, //禁用的公式编辑区按钮key
    isValidateOnOK: PropTypes.bool, //点击确定后是否需要验证
    defaultAttrKey: PropTypes.string, //属性tabs默认展示的页签
    defaultFormulaKey: PropTypes.string, //公式tabs默认展示的页签
    tabActiveKey: PropTypes.string, //公式tabs当前展示的页签
};